import styled from 'styled-components';
import { Divider, Form } from 'semantic-ui-react';

const Container = styled.div`
  border-radius: 1.3rem;
  min-width: 0px;
  flex: 1 1 0%;
  background-color: rgb(241 245 249);
  box-shadow: 0 0 #0000, 0 0 #000000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  min-height: calc(100vh - 113px);
  * {
  font-size: 16x !important;
}
`;

const Heading = styled.h1`
  font-size: 24px !important; 
  font-weight: bold; 
  line-height: 40px; 
  text-align: center;
  margin: 0;
  margin-left: 10%;
`;

const StyledContent = styled.div<{ $isFirstStep?: boolean }>`
padding: 20px;
padding-top: 0px;
margin-bottom: 40px;
.ui.divider {
 margin-top: 0px !important;  
 background-color: ${props => props.theme.firstColor} !important;
}
`

const StepsContainer = styled.div`
  position: relative;
  min-height: fit-content;
  margin-bottom: 20px;
  .bar {
    background: ${props => props.theme.firstColor} !important;
  }
`;

const Steps = styled.div`
  display: flex;
  justify-content: space-around;  
`;

const Step = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  z-index: 2;
  align-items: center;
  color: ${props => (props.$active ? props.theme.firstColor : props.theme.secondColor)};
  position: relative;
   .stepTitle {
    position: absolute;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden; 
    top: 60px;
    font-size: 15px !important;
    font-weight: ${props => props.$active ? 'bold' : '400'};
   }
`;

const StepIcon = styled.div<{ $active?: boolean, $dataLoaded?: boolean }>`
  background: linear-gradient(90deg, ${props => props.theme.firstColor} 0%, ${props => props.theme.secondColor} 100%);
  border-radius: 50%;
  color: #fff;
  cursor: ${props => props.$dataLoaded ? 'pointer' : 'default'};
  border: ${props => props.$active ? '3px solid white' : 'none'};
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  ${props => props.$active ? 'box-shadow: 0px 2px 2px 2px rgb(0 0 0 / 35%);' : ''};  
  line-height: 50px;
  margin-bottom: 10px;
  width: 50px;
  div {
    font-size: 25px !important;  
  }
  .ui.loader {
    top: 43% !important;
  }
`;

const WizzardContentWrapper = styled(Form)`
background: white;
min-height: 460px;
border-bottom-left-radius: 1.3rem;
border-bottom-right-radius: 1.3rem;
display: flex;
flex-direction: column;
 .disabled {
  opacity: 0.8 !important;
 }
`
const ActionsContainer = styled.div<{ $activeTab?: number }>`
display: flex;
align-items: center;
gap: 100px;
position: absolute;
width: 330px;
bottom: 0px;
left: calc(50% - 165px);
justify-content: center;
 button {
  color: white !important;
 }
`
export const StyledDivider = styled(Divider)`
color: ${props => props.theme.firstColor};
margin-top: -6px !important;
`
export const BillingWrapper = styled.div`
display: flex;
gap: 20px;
justify-content: space-around; 
 .billing {
    display: flex;
    align-items: center;
    white-space: nowrap;
    gap: 10px;
    margin-bottom: 5px;
 }
 .billing-value {
  font-weight: bold;
  text-align: center;
 }
`

export const CO2El = {
  ActionsContainer,
  WizzardContentWrapper,
  Step,
  StepIcon,
  Steps,
  StyledContent,
  Container,
  Heading,
  StyledDivider,
  StepsContainer,
  BillingWrapper
}